import { MODULE_CODES, type Question } from '../../../../../../content';

/**
 * Extract short module code from a question, handling the TGL prefix correctly.
 *
 * Authority order:
 *   1. `question.module` (post-TGL-split, authoritative)
 *   2. Parse from questionId prefix (TGL-GELD-… / TGL-TIJD-… → GELD / TIJD)
 *
 * Extracted from useGovernanceData.ts (R1) so every derivation function uses
 * the exact same resolution. Tested implicitly by module-health rollups.
 */
export function resolveModuleCode(question: Question | undefined, questionId: string): string {
  if (question?.module) {
    return MODULE_CODES[question.module] || question.module;
  }
  const parts = questionId.split('-');
  if (parts[0] === 'TGL' && parts.length >= 2) {
    if (parts[1] === 'GELD') return 'GELD';
    if (parts[1] === 'TIJD') return 'TIJD';
  }
  return parts[0] || 'UNKNOWN';
}